"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var baseTheme_exports = {};
__export(baseTheme_exports, {
  BaseTheme: () => BaseTheme,
  default: () => baseTheme_default
});
module.exports = __toCommonJS(baseTheme_exports);
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
var breakpoints = {
  xs: "0px",
  // For 400% Zoom, the “small” layout size applies for viewports/breakpoints for screen width of 320px to 679px.
  sm: "320px",
  // For 200% Zoom, the “medium” layout size applies for viewports/breakpoints for screen width of 680px to 1023px.
  md: "680px",
  lg: "1024px",
  xl: "1600px"
};
var colors = {
  black: "#000000",
  // FIXME: redundant with n.100, deprecated
  white: "#FFFFFF",
  // FIXME: redundant with n.white, deprecated
  // Brand colors
  pr: {
    10: "#E9F7FB",
    20: "#DAF3F6",
    40: "#BFE6EB",
    60: "#ABD5D8",
    80: "#A0C5C2",
    100: "#96B5AD",
    120: "#7CA3A1",
    140: "#649295",
    base: "#407177",
    170: "#355F64",
    180: "#2C4E53"
    /* previous primary.180 color */
  },
  beige: {
    20: "#FAFBF9",
    40: "#F6F7F3",
    60: "#F2F4ED",
    80: "#EEF0E7",
    100: "#EAEDE1",
    120: "#DDDFCA",
    140: "#C4C2AA",
    160: "#9D9880",
    180: "#706C5C"
  },
  khaki: {
    20: "#FAFBF9",
    40: "#F6F3EA",
    60: "#EEE8D5",
    80: "#E8E1C7",
    100: "#E3DABA",
    120: "#D3C491",
    140: "#C4B069",
    160: "#A38E44",
    180: "#877329"
  },
  olive: {
    20: "#EBF5CD",
    40: "#D9EBA0",
    60: "#C7E07D",
    80: "#BFD374",
    100: "#B7C378",
    120: "#A4B366",
    140: "#7F8F4A",
    160: "#606D37",
    180: "#424D25"
  },
  terracotta: {
    20: "#FFECDB",
    40: "#FFC898",
    60: "#FFB474",
    80: "#F1985A",
    100: "#E4844F",
    120: "#D16D37",
    140: "#C05920",
    160: "#9C4719",
    180: "#793714"
  },
  gmBlue: {
    base: "#0F526F",
    "dark-60": "#638EA1",
    "dark-80": "#3D738A",
    "light-20": "#E6EDF0",
    "light-40": "#9FBAC5"
  },
  // Neutral colors
  n: {
    white: "#FFFFFF",
    "01": "#FCFCFC",
    "04": "#F5F5F5",
    10: "#E5E5E5",
    20: "#CCCCCC",
    30: "#B3B3B3",
    40: "#999999",
    50: "#7F7F7F",
    60: "#666666",
    80: "#333333",
    85: "#252525",
    90: "#181818",
    100: "#000000"
    /* replaces colors.black */
  },
  // Neutral Alpha colors
  neutralAlpha: {
    n100Alpha40: "rgba(0, 0, 0, 0.4)",
    n100Alpha15: "rgba(0, 0, 0, 0.15)",
    whiteAlpha40: "rgba(255, 255, 255, 0.4)",
    whiteAlpha15: "rgba(255, 255, 255, 0.15)"
  },
  // Curriculum colors
  em1: {
    20: "#DBEECD",
    40: "#B9E29C",
    base: "#7EBB52",
    60: "#498A28",
    80: "#1A661A"
  },
  em2: {
    20: "#FCDECF",
    40: "#F78C64",
    base: "#FF5B35",
    60: "#E55427",
    80: "#D93D1A"
  },
  phD: {
    20: "#E7DBF0",
    40: "#B798CD",
    base: "#845AA2",
    60: "#724494",
    80: "#65328A"
  },
  witWisdom: {
    20: "#D1EBFA",
    40: "#8FCFF3",
    base: "#7CC7F1",
    60: "#64B8E9",
    80: "#46A6DE"
  },
  planning: {
    primary: {
      base: "#853A5F"
    },
    artsAndLetters: {
      base: "#008AB6",
      10: "#DFECF3",
      60: "#478394",
      100: "#055871"
    }
  },
  // Status colors
  status: {
    error: {
      20: "#FAE5E1",
      100: "#C42A2A",
      120: "#AD2323",
      140: "#891E1E"
    },
    warning: {
      20: "#F7ECC9",
      100: "#E07000"
    },
    success: {
      20: "#D6F6E3",
      100: "#018939"
    }
  },
  // Auxiliar colors
  aux: {
    pBlue: {
      100: "#CAE4F3",
      200: "#9ED4FF"
    },
    pOrange: {
      100: "#FFD4A6",
      200: "#FF9A48"
    },
    pYellow: {
      100: "#FAEC8F",
      200: "#F9CD19"
    },
    pGreen: {
      100: "#BEF3B3",
      200: "#7DE071"
    },
    pPurple: {
      100: "#D6C8FF",
      200: "#C37EDA"
    }
  },
  // Highlight colors
  highlight: {
    yellow: "#FADE7D",
    pink: "#F6C5D3",
    green: "#DCE9A8",
    blue: "#C7E5EA"
  },
  //
  correct: {
    base: "#67B430",
    "dark-80": "#CDD1DD",
    "light-20": "#EDEEF2"
  },
  incorrect: {
    base: "#C42A2A",
    "dark-80": "#911F1F",
    "light-20": "#F2C2C2"
  },
  neutral: {
    base: "#E6E8EA",
    "dark-60": "#CCD3D5",
    "light-20": "#FCFCFC",
    "light-30": "#F5F6F7",
    "light-40": "#EDF0F2"
  },
  // FIXME: primary is deprecated in favor of pr
  primary: {
    base: "#0B212C",
    "dark-60": "#647881",
    "dark-80": "#4A5D66",
    "light-40": "#A6B5BD",
    "light-50": "#7D9099",
    "light-60": "#ABD5D8",
    0: "#407177",
    100: "#96B5AD",
    120: "#7CA3A1",
    140: "#649295",
    170: "#355F64",
    180: "#2C4E53"
  },
  transparent: {
    base: "transparent",
    black: "rgba(0, 0, 0, 16%)"
  },
  // FIXME: warning is deprecated
  warning: {
    base: "#EEBB0B",
    "dark-80": "#D93D1A",
    "light-20": "#E65427"
  },
  // FIXME: pBlue is deprecated in favor of aux.pBlue
  pBlue: {
    100: "#9ED4FF",
    20: "#CADEF3",
    10: "#E9F7FB"
  }
};
var measurements = {
  extraExtraLarge: "20px",
  extraExtraSmall: "1px",
  extraLarge: "16px",
  extraSmall: "2px",
  large: "12px",
  medium: "8px",
  shadows: {
    "elevation-1": "0px 1px 1px 0px",
    "elevation-2": "0px 1px 3px 0px",
    "elevation-3": "0px 2px 4px 0px",
    "elevation-4": "0px 4px 8px 0px",
    "elevation-5": "0px 8px 16px 0px",
    "elevation-6": "0px 16px 24px 0px",
    medium: "0px 0px 0px 5px",
    small: "0px 0px 0px 2px",
    extraSmall: "0px 0px 0px 1px"
  },
  small: "4px",
  zero: "0"
};
var borderRadius = {
  none: "0",
  small: "0.125rem",
  // 2px
  medium: "0.25rem",
  // 4px
  large: "1rem",
  // 16px
  xLarge: "3.5rem",
  // 56px
  circle: "25rem"
  // 400px
};
var typography = {
  // New keys matching with our Design System
  headings: {
    h1: "1rem",
    // 16px
    h2: "1.375rem",
    // 22px
    h3: "1.125rem",
    // 18px
    h4: "0.875rem"
    // 14px
  },
  titles: {
    huge: "3.5rem",
    // 56px
    page: "2.75rem",
    // 44px
    main: "2.25rem",
    // 36px
    subtitle: "1.625rem",
    // 26px
    minor: "0.75rem"
    // 12px
  },
  textStyles: {
    textBase: "1rem",
    // 16px
    textSmall: "0.875rem",
    // 14px
    textLink: "0.875rem",
    // 14px
    button: "0.875rem"
    // 14 : 16
  },
  fonts: {
    primary: "Circular Std",
    studentExp: "Quicksand",
    teacherExp: "Circular Std",
    fontSans: "Circular Std"
  },
  // Old keys to be replaced with keys above
  rootFontSize: "16px",
  sizes: {
    extraExtraHuge: "3.5rem",
    // 56px
    extraExtraLarge: "1.625rem",
    // 26px
    extraHuge: "3.25rem",
    // 52px
    extraLarge: "1.375rem",
    // 22px
    extraSmall: "0.75rem",
    // 12px
    huge: "2.25rem",
    // 36px
    large: "1.125rem",
    // 18px
    medium: "1rem",
    // 16px
    small: "0.875rem"
    // 14px
  },
  weights: {
    regular: "400",
    medium: "500",
    bold: "700",
    black: "900"
  }
};
var iconology = {
  sizes: {
    small: "1.0625rem",
    // 17px
    medium: "1.25rem",
    // 20px
    large: "1.5rem",
    // 24px
    xLarge: "2rem"
    // 32px
  },
  standardIconSize: {
    s: 17,
    // 17px small
    m: 20,
    // 20px medium
    l: 24,
    // 24px large
    xl: 32
    // 32px extraLarge
  }
};
var baseTheme = {
  colors,
  measurements,
  borderRadius,
  typography,
  iconology,
  breakpoints
};
var BaseTheme = _typeof(baseTheme);
var baseTheme_default = baseTheme;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  BaseTheme
});
//# sourceMappingURL=baseTheme.js.map